export const profilePosts = (state) => {
  return state.profilePosts;
};
